import {
  LongTextField,
  ReferenceListField,
  useFieldLabel,
  useTabVisibility,
} from "ra-friendsofbabba";

import MonthsField from "../../research-project-activities/fields/MonthsField";
import RangeField from "../../research-project-activities/fields/RangeField";
import React from "react";

const ActivitiesField = ({ tab = 2, ...props }) => {
  const fieldLabel = useFieldLabel({ resource: "research-project-activities" });
  const visible = useTabVisibility(tab);
  if (!visible) {
    return null;
  }
  return (
    <ReferenceListField
      {...props}
      tab={tab}
      perPage={5}
      reference="research-project-activities"
      target="research_project_id"
      sort={{ field: "range", order: "ASC" }}
      create={!props.disabled}
      modify={!props.disabled}
      remove={!props.disabled}
    >
      <RangeField source="range" sortBy="range" variant="body2" />
      <LongTextField source="title" maxRows={1} variant="body2" />
      <MonthsField
        source="public_months"
        label={fieldLabel("months.public")}
        variant="body2"
      />
      <MonthsField
        source="private_months"
        label={fieldLabel("months.private")}
        variant="body2"
      />
      <MonthsField
        source="foreign_months"
        label={fieldLabel("months.foreign")}
        variant="body2"
      />
    </ReferenceListField>
  );
};

export default ActivitiesField;
